import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import LedProduct from '../components/ledProduct/LedProduct';
//import Footer from '../components/footer/Footer';

const LedProductPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <LedProduct />
            </main>

            {/* <Footer /> */}

            <TopButton />
        </>
    );
};

export default LedProductPage;